"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableButton = void 0;
var react_1 = __importDefault(require("react"));
var EditOutlined_1 = __importDefault(require("@material-ui/icons/EditOutlined"));
var VisibilityOutlined_1 = __importDefault(require("@material-ui/icons/VisibilityOutlined"));
var SettingsBackupRestoreOutlined_1 = __importDefault(require("@material-ui/icons/SettingsBackupRestoreOutlined"));
var DeleteForeverOutlined_1 = __importDefault(require("@material-ui/icons/DeleteForeverOutlined"));
var DescriptionOutlined_1 = __importDefault(require("@material-ui/icons/DescriptionOutlined"));
var CsButton_1 = __importDefault(require("../Buttons/CsButton"));
var react_i18next_1 = require("react-i18next");
exports.DataTableButton = react_1.default.memo(function (_a) {
    var condition = _a.condition, action = _a.action, title = _a.title, id = _a.id, onButtonClicked = _a.onButtonClicked;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement(react_1.default.Fragment, null, condition && (react_1.default.createElement(CsButton_1.default, { style: { marginLeft: '10px !important', marginBottom: '5px !important' }, title: t(title), id: id, color: 'primary', small: true, textButton: true, onClick: onButtonClicked },
        action === 'edit' && react_1.default.createElement(EditOutlined_1.default, null),
        action === 'view' && react_1.default.createElement(VisibilityOutlined_1.default, null),
        action === 'restore' && react_1.default.createElement(SettingsBackupRestoreOutlined_1.default, null),
        action === 'delete' && react_1.default.createElement(DeleteForeverOutlined_1.default, null),
        action === 'generate' && react_1.default.createElement(DescriptionOutlined_1.default, null)))));
});
exports.DataTableButton.displayName = 'DataTableButton';
exports.default = exports.DataTableButton;
//# sourceMappingURL=DataTableButton.js.map